var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.boletim.documento)?_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.pdfDataUrl,"width":"100%","height":"900px"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }